const BASE_CONFIG = {
  pre_payment_page: {
    meta: {
      version: 1,
      page_id: 'pre_payment_page',
    },
    layout: {
      display: 'flex',
      flexDirection: 'column',
      width: '100%',
      minHeight: '100vh',
      background: '#F4F6FA',
      fontSize: 16,
    },
    styles: {
      fontFamily: 'Georama',
    },
    responsive: {
      mobile: {
        fontSize: '0.8rem'
      },
    },
    children: [
      {
        id: 'page_content_wrapper',
        component: 'Container',
        layout: {
          display: 'flex',
          flexDirection: 'row',
          gap: '32px',
          padding: '90px 16px',
          width: '100%',
          maxWidth: '1400px',
          margin: '0 auto',
        },
        responsive: {
          mobile: {
            flexDirection: 'column',
            overflowY: 'scroll',
            padding: '4px 24px 0px 24px',
          },
        },
        children: [
          {
            id: 'left_panel',
            component: 'Container',
            layout: {
              display: 'flex',
              flexDirection: 'column',
              gap: '0.75rem',
              width: '65%',
            },
            responsive: {
              mobile: {
                width: '100%',
              },
            },
            children: [
              {
                id: 'mobile_header',
                component: 'Container',
                layout: {},
                styles: {
                  display: "none"
                },
                responsive: {
                  mobile: {
                    display: 'flex',
                    justifyContent: 'flex-end',
                    marginTop: '8px',
                    fontSize: '0.7rem',
                    alignItems: 'center'
                  },
                },
                children: [
                  {
                    id: 'powered_by_text',
                    component: 'Text',
                    default_value: 'Powered by',
                    styles: {
                      color: '#6B7280',
                    },
                  },
                  {
                    id: 'easebuzz_logo',
                    component: 'Image',
                    props: {
                      src: 'data:image/png;base64,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',
                    },
                    styles: {
                      height: '18px',
                      width: '6rem',
                      objectFit: 'contain',
                    },
                    responsive: {
                      mobile: {
                        height: '0.7rem',
                        width: '5rem'
                      },
                    },
                  },
                ],
              },
              {
                id: 'header_card',
                component: 'Container',
                layout: {
                  width: '100%',
                },
                styles: {
                  background: '#000000',
                  padding: '24px',
                  borderRadius: '16px',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '16px',
                  color: '#FFFFFF',
                  boxShadow: '0 8px 24px rgba(0,0,0,0.08)',
                },
                children: [
                  {
                    id: 'merchant_logo',
                    component: 'Image',
                    props: {
                      src: 'data:image/png;base64,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',
                      alt: 'merchant_logo',
                    },
                    layout: {},
                    styles: {
                      width: '82px',
                      height: '62px',
                      zoom: 1.3,
                      borderRadius: '12px',
                      objectFit: 'contain',
                      background: '#FFFFFF',
                      padding: '8px',
                    },
                  },
                  {
                    id: 'main_link_details',
                    component: 'Container',
                    styles: {
                      display: 'flex',
                      flexDirection: 'column',
                      justifyContent: 'flex-end',
                      fontSize: '1.5rem',
                      opacity: 0.9,
                    },
                    children: [
                      {
                        id: 'payment_in_progress_wrapper',
                        component: 'Container',
                        layout: {
                          width: '100%',
                        },
                        styles: {
                          display: 'flex',
                          flexDirection: 'row',
                          margin: '10px 0px',
                        },
                        responsive: {
                          mobile: {
                            display: 'block',
                            margin: '10px 0px',
                          },
                        },
                        children: [
                          {
                            id: 'paying_to_merchant_pretext',
                            component: 'Text',
                            default_value: 'Payment in progress',
                            styles: {
                              fontWeight: '700'
                            },
                          }
                        ],
                      },
                    ],
                  },
                ],
              },
              {
                id: 'customer_information_card',
                component: 'Container',
                layout: {
                  width: '100%',
                },
                styles: {
                  background: '#FFFFFF',
                  padding: '32px',
                  borderRadius: '16px',
                  minHeight: "60vh",
                  boxShadow: '0 8px 24px rgba(0,0,0,0.06)',
                  overflowY: "auto",
                  wordWrap: 'break-word',
                  fontSize: '1.1rem'
                },
                responsive: {
                  mobile: {
                    minHeight: '66vh',
                  },
                },
                children: [
                  {
                    id: 'title_wrapper',
                    component: 'Container',
                    styles: {
                      display: 'flex',
                      flexDirection: 'row',
                      borderRadius: '16px',
                      padding: '0px 0px 4px',
                      fontWeight: 900,
                      fontSize: '1.7rem'
                    },
                    children: [
                      {
                        id: 'title_pretext',
                        component: 'Text',
                        default_value: 'Hi',
                        styles: {
                          marginRight: '4px',
                        },
                      },
                      {
                        id: 'title_value',
                        component: 'Text',
                        dataKey: 'firstname',
                        default_value: '',
                        styles: {},
                      },
                      {
                        id: 'title_posttext',
                        component: 'Text',
                        default_value: ',',
                        styles: {},
                      },
                    ],
                  },
                  {
                    id: 'subtitle',
                    component: 'Text',
                    layout: {
                      width: '100%',
                    },
                    default_value: 'Please confirm your information',
                    styles: {
                      color: 'rgba(0, 0, 0, 0.65)',
                      borderRadius: '16px',
                      marginBottom: '18px',
                    },
                  },
                  {
                    id: 'mobile_number_wrapper',
                    component: 'Container',
                    layout: {
                      display: 'flex',
                      flexDirection: 'column',
                      marginBottom: '16px',
                    },
                    children: [
                      {
                        id: 'mobile_number_label',
                        component: 'Text',
                        dataKey: 'easycollect_fields.phone',
                        default_value: 'Mobile Number',
                        styles: {
                          fontWeight: '500',
                          color: '#6B7280',
                        },
                      },
                      {
                        id: 'mobile_number_value',
                        component: 'Text',
                        dataKey: 'phone',
                        default_value: '',
                        styles: {
                          color: '#111827',
                        },
                      },
                    ],
                  },
                  {
                    id: 'email_wrapper',
                    component: 'Container',
                    visibility: {
                      dataKey: 'email',
                      operator: 'exists',
                    },
                    layout: {
                      display: 'flex',
                      flexDirection: 'column',
                      marginBottom: '16px',
                    },
                    children: [
                      {
                        id: 'email_label',
                        component: 'Text',
                        dataKey: 'easycollect_fields.email',
                        default_value: 'Email ID',
                        styles: {
                          fontWeight: '500',
                          color: '#6B7280',
                        },
                      },
                      {
                        id: 'email_value',
                        component: 'Text',
                        dataKey: 'email',
                        default_value: '',
                        styles: {
                          color: '#111827',
                        },
                      },
                    ],
                  },
                  {
                    id: 'udf1_wrapper',
                    component: 'Container',
                    layout: {
                      display: 'flex',
                      flexDirection: 'column',
                      marginBottom: '16px',
                    },
                    visibility: {
                      dataKey: 'udf1',
                      operator: 'exists',
                    },
                    children: [
                      {
                        id: 'udf1_label',
                        component: 'Text',
                        dataKey: 'easycollect_fields.udf1',
                        default_value: 'UDF1',
                        styles: {
                          fontWeight: '500',
                          color: '#6B7280',
                        },
                      },
                      {
                        id: 'udf1_value',
                        component: 'Text',
                        dataKey: 'udf1',
                        default_value: '',
                        styles: {
                          color: '#111827',
                        },
                      },
                    ],
                  },
                  {
                    id: 'udf2_wrapper',
                    component: 'Container',
                    layout: {
                      display: 'flex',
                      flexDirection: 'column',
                      marginBottom: '16px',
                    },
                    visibility: {
                      dataKey: 'udf2',
                      operator: 'exists',
                    },
                    children: [
                      {
                        id: 'udf2_label',
                        component: 'Text',
                        dataKey: 'easycollect_fields.udf2',
                        default_value: 'UDF2',
                        styles: {
                          fontWeight: '500',
                          color: '#6B7280',
                        },
                      },
                      {
                        id: 'udf2_value',
                        component: 'Text',
                        dataKey: 'udf2',
                        default_value: '',
                        styles: {
                          color: '#111827',
                        },
                      },
                    ],
                  },
                  {
                    id: 'udf3_wrapper',
                    component: 'Container',
                    layout: {
                      display: 'flex',
                      flexDirection: 'column',
                      marginBottom: '16px',
                    },
                    visibility: {
                      dataKey: 'udf3',
                      operator: 'exists',
                    },
                    children: [
                      {
                        id: 'udf3_label',
                        component: 'Text',
                        dataKey: 'easycollect_fields.udf3',
                        default_value: 'UDF3',
                        styles: {
                          fontWeight: '500',
                          color: '#6B7280',
                        },
                      },
                      {
                        id: 'udf3_value',
                        component: 'Text',
                        dataKey: 'udf3',
                        default_value: '',
                        styles: {
                          color: '#111827',
                        },
                      },
                    ],
                  }
                ],
              },
              // {
              //   id: 'customer_footer_wrapper',
              //   component: 'Container',
              //   layout: {
              //     marginTop: '8px',
              //     display: 'flex',
              //     flexDirection: 'row',
              //     color: '#6B7280',
              //   },
              //   responsive: {
              //     mobile: {
              //       display: 'none',
              //     },
              //   },
              //   children: [
              //     {
              //       id: 'contact_support_pretext',
              //       component: 'Text',
              //       default_value: 'For any queries, please contact us at',
              //       styles: {
              //         paddingRight: '5px',
              //       },
              //     },
              //     {
              //       id: 'contact_support_value',
              //       component: 'Link',
              //       default_value: 'support@merchant.com',
              //       props: {
              //         href: 'mailto:support@merchant.com',
              //       },
              //       styles: {
              //         textDecoration: 'underline',
              //       },
              //     },
              //   ],
              // },
            ],
          },
          {
            id: 'right_panel',
            component: 'Container',
            layout: {
              display: 'flex',
              flexDirection: 'column',
              gap: '24px',
              width: '35%',
            },
            responsive: {
              mobile: {
                width: '100%',
              },
            },
            children: [
              {
                id: 'payment_action_card',
                component: 'Container',
                styles: {
                  background: '#FFFFFF',
                  padding: '32px',
                  borderRadius: '16px',
                  boxShadow: '0 8px 24px rgba(0,0,0,0.06)',
                },
                responsive: {
                  mobile: {
                    position: 'fixed',
                    bottom: '0',
                    left: '0',
                    width: '100%',
                    zIndex: '999',
                    background: '#FFFFFF',
                    padding: '20px',
                    borderRadius: '24px 24px 0 0',
                    boxShadow: '0 -4px 24px rgba(0,0,0,0.12)',
                  },
                },
                children: [
                  {
                    id: 'payment_summary_card',
                    component: 'Container',
                    styles: {
                      background: '#F5F7FF',
                      borderRadius: '14px',
                      padding: '20px',
                      display: 'flex',
                      flexDirection: 'column',
                      gap: '16px',
                      marginBottom: '20px',
                    },
                    visibility: {
                      dataKey: 'payment_type',
                      operator: 'equals',
                      value: 'PP',
                    },
                    children: [
                      {
                        id: 'payment_summary_header',
                        component: 'Container',
                        layout: {
                          display: 'flex',
                          justifyContent: 'space-between',
                          alignItems: 'center',
                        },
                        children: [
                          {
                            id: 'summary_title',
                            component: 'Text',
                            default_value: 'Payment Summary',
                            styles: {
                              fontSize: '18px',
                              fontWeight: '700',
                              color: '#1E293B',
                            },
                          },
                          {
                            id: 'payment_history',
                            component: 'Text',
                            default_value: 'Payment History',
                            styles: {
                              fontSize: '14px',
                              color: '#4F46E5',
                              cursor: 'pointer',
                              textDecoration: 'underline',
                            },
                          },
                        ],
                      },
                      {
                        id: 'total_amount_row',
                        component: 'Container',
                        layout: {
                          display: 'flex',
                          justifyContent: 'space-between',
                        },
                        children: [
                          {
                            id: 'total_amount_label',
                            component: 'Text',
                            default_value: 'Total Amount',
                            styles: {
                              fontSize: '15px',
                              color: '#64748B',
                            },
                          },
                          {
                            id: 'total_amount_value_wrapper',
                            component: 'Container',
                            dataKey: 'amount',
                            styles: {
                              display: 'flex',
                              flexDirection: 'row',
                              fontSize: '15px',
                              fontWeight: '600',
                              color: '#111827',
                            },
                            children: [
                              {
                                id: 'total_amount_value_pretext',
                                component: 'Text',
                                default_value: '₹',
                                styles: {
                                  marginRight: '5px',
                                },
                              },
                              {
                                id: 'total_amount_value',
                                component: 'Text',
                                dataKey: 'due_amount',
                              },
                            ],
                          },
                        ],
                      },
                      {
                        id: 'amount_paid_row',
                        component: 'Container',
                        layout: {
                          display: 'flex',
                          justifyContent: 'space-between',
                        },
                        children: [
                          {
                            id: 'amount_paid_label',
                            component: 'Text',
                            default_value: 'Amount Paid',
                            styles: {
                              fontSize: '15px',
                              color: '#64748B',
                            },
                          },
                          {
                            id: 'amount_paid_wrapper',
                            component: 'Container',
                            styles: {
                              display: 'flex',
                              flexDirection: 'row',
                              fontSize: '15px',
                              fontWeight: '600',
                              color: '#111827',
                            },
                            children: [
                              {
                                id: 'amount_paid_value_pretext',
                                component: 'Text',
                                default_value: '₹',
                                styles: {
                                  marginRight: '5px',
                                },
                              },
                              {
                                id: 'amount_paid_value',
                                component: 'Text',
                                dataKey: 'amount_collected_so_far',
                              },
                            ],
                          },
                        ],
                      },
                      {
                        id: 'summary_divider',
                        component: 'Container',
                        styles: {
                          width: '100%',
                          height: '1px',
                          background: '#E2E8F0',
                        },
                      },
                      {
                        id: 'amount_due_row',
                        component: 'Container',
                        layout: {
                          display: 'flex',
                          justifyContent: 'space-between',
                          alignItems: 'center',
                        },
                        children: [
                          {
                            id: 'amount_due_label',
                            component: 'Text',
                            default_value: 'Amount Due',
                            styles: {
                              fontSize: '18px',
                              fontWeight: '700',
                              color: '#1E293B',
                            },
                          },
                          {
                            id: 'amount_due_value_wrapper',
                            component: 'Container',
                            styles: {
                              display: 'flex',
                              flexDirection: 'row',
                              fontSize: '22px',
                              fontWeight: '800',
                              color: '#111827',
                            },
                            children: [
                              {
                                id: 'amount_due_value_pretext',
                                component: 'Text',
                                default_value: '₹',
                                styles: {
                                  marginRight: '5px',
                                },
                              },
                              {
                                id: 'amount_due_value',
                                component: 'Text',
                                dataKey: 'due_amount',
                              },
                            ],
                          },
                        ],
                      },
                    ],
                  },
                  {
                    id: 'payment_title',
                    component: 'Text',
                    default_value: 'Payment Amount',
                    styles: {
                      fontSize: '18px',
                      fontWeight: '500',
                    },
                    responsive: {
                      mobile: {
                        display: 'none',
                      },
                    },
                  },
                  {
                    id: 'variable_amount',
                    component: 'InputField',
                    default_value: '',
                    dataKey: 'due_amount',
                    placeholder: 'Enter amount',
                    visibility: {
                      dataKey: 'payment_type',
                      operator: 'equals',
                      value: 'PP',
                    },
                    styles: {
                      width: '100%',
                      height: '56px',
                      border: '1px solid #D1D5DB',
                      borderRadius: '12px',
                      padding: '0 16px',
                      fontSize: '42px',
                      fontWeight: '700',
                      color: '#111827',
                    },
                  },
                  {
                    id: 'payment_amount_wrapper',
                    component: 'Container',
                    styles: {
                      fontSize: '48px',
                      fontWeight: '900',
                      display: 'flex',
                      flexDirection: 'row',
                      margin: '16px 0px',
                    },
                    responsive: {
                      mobile: {
                        display: 'none',
                      },
                    },
                    children: [
                      {
                        id: 'payment_amount_pretext',
                        component: 'Text',
                        default_value: '₹',
                        styles: {
                          marginRight: '18px',
                        },
                      },
                      {
                        id: 'payment_amount_value',
                        component: 'Text',
                        dataKey: 'amount',
                        default_value: '',
                      },
                    ],
                  },
                  {
                    id: 'tpv_bank_details_card',
                    component: 'Container',
                    visibility: {
                      dataKey: 'tpv_details.account_ifsc',
                      operator: 'exists',
                    },
                    styles: {
                      display: 'flex',
                      alignItems: 'center',
                      gap: '16px',
                      padding: '16px',
                      border: '1px solid #E5E7EB',
                      borderRadius: '14px',
                      background: '#FFFFFF',
                      marginBottom: '20px',
                    },
                    children: [
                      {
                        id: 'tpv_bank_logo',
                        component: 'Image',
                        dataKey: 'tpv_details.bank_logo',
                        default_value: 'https://example.com/default-bank-logo.png',
                        styles: {
                          width: '52px',
                          height: '52px',
                          borderRadius: '10px',
                          objectFit: 'contain',
                          background: '#FFFFFF',
                          border: '1px solid #F3F4F6',
                          padding: '6px',
                        },
                      },
                      {
                        id: 'tpv_bank_content',
                        component: 'Container',
                        styles: {
                          display: 'flex',
                          flexDirection: 'column',
                          gap: '6px',
                          flex: 1,
                        },
                        children: [
                          {
                            id: 'tpv_bank_name',
                            component: 'Text',
                            dataKey: 'tpv_details.account_ifsc',
                            styles: {
                              fontSize: '16px',
                              fontWeight: '600',
                              color: '#111827',
                            },
                          },
                          {
                            id: 'tpv_account_number',
                            component: 'Text',
                            dataKey: 'tpv_details.bank_account_number',
                            styles: {
                              fontSize: '14px',
                              color: '#6B7280',
                            },
                          },
                        ],
                      },
                    ],
                  },
                  {
                    id: 'autodebit_details_card',
                    component: 'Container',
                    visibility: {
                      dataKey: 'is_auto_debit_link',
                      operator: 'equals',
                      value: true,
                    },
                    styles: {
                      gap: '24px',
                      gridTemplateColumns: '1fr',
                      marginBottom: '20px',
                    },
                    responsive: {
                      mobile: {
                        display: 'grid',
                        gridTemplateColumns: '1fr 1fr',
                        gap: '18px',
                      },
                    },
                    children: [
                      {
                        id: 'autodebit_grid',
                        component: 'Container',
                        styles: {
                          display: 'flex',
                          flexDirection: 'column',
                          fontSize: '22px',
                        },
                        children: [
                          {
                            id: 'mandate_start_date_wrapper',
                            component: 'Container',
                            styles: {
                              display: 'flex',
                              flexDirection: 'row',
                              justifyContent: 'space-between',
                              gap: '6px',
                            },
                            visibility: {
                              dataKey: 'debit_details.auto_debit_type',
                              operator: 'equals',
                              value: 'ENACH',
                            },
                            children: [
                              {
                                id: 'mandate_start_date_label',
                                component: 'Text',
                                default_value: 'Start Date',
                                styles: {
                                  color: '#6B7280',
                                },
                              },
                              {
                                id: 'mandate_start_date_value',
                                component: 'Text',
                                dataKey: 'debit_details.mandate_start_date',
                                styles: {},
                              },
                            ],
                          },
                          {
                            id: 'final_collection_date_wrapper',
                            component: 'Container',
                            styles: {
                              display: 'flex',
                              flexDirection: 'row',
                              justifyContent: 'space-between',
                              gap: '6px',
                            },
                            children: [
                              {
                                id: 'final_collection_date_label',
                                component: 'Text',
                                default_value: 'End Date',
                                styles: {
                                  fontSize: '13px',
                                  color: '#6B7280',
                                },
                              },
                              {
                                id: 'final_collection_date_value',
                                component: 'Text',
                                dataKey: 'debit_details.final_collection_date',
                                styles: {
                                  fontSize: '15px',
                                },
                              },
                            ],
                          },
                          {
                            id: 'frequency_wrapper',
                            component: 'Container',
                            styles: {
                              display: 'flex',
                              flexDirection: 'row',
                              justifyContent: 'space-between',
                              gap: '6px',
                            },
                            children: [
                              {
                                id: 'frequency_label',
                                component: 'Text',
                                default_value: 'Frequency',
                                styles: {
                                  fontSize: '13px',
                                  color: '#6B7280',
                                },
                              },
                              {
                                id: 'frequency_value',
                                component: 'Text',
                                dataKey: 'debit_details.frequency',
                                styles: {
                                  fontSize: '15px',
                                  fontWeight: '600',
                                },
                              },
                            ],
                          },
                          {
                            id: 'max_debit_amount_wrapper',
                            component: 'Container',
                            styles: {
                              display: 'flex',
                              flexDirection: 'row',
                              justifyContent: 'space-between',
                              gap: '6px',
                            },
                            children: [
                              {
                                id: 'max_debit_amount_label',
                                component: 'Text',
                                default_value: 'Amount',
                                styles: {
                                  fontSize: '13px',
                                  color: '#6B7280',
                                },
                              },
                              {
                                id: 'max_debit_amount_value',
                                component: 'Text',
                                dataKey: 'debit_details.max_debit_amount',
                                styles: {
                                  fontSize: '15px',
                                },
                              },
                            ],
                          },
                        ],
                      },
                    ],
                  },
                  {
                    id: 'pay_button_wrapper',
                    component: 'Button',
                    styles: {
                      display: 'flex',
                      flexDirection: 'row',
                      justifyContent: 'center',
                      alignItems: 'center',
                      width: '100%',
                      height: '56px',
                      border: 'none',
                      borderRadius: '14px',
                      background: '#000000',
                      color: '#FFFFFF',
                      fontSize: '1.5rem',
                      fontWeight: '900',
                      cursor: 'pointer',
                    },
                    actions: {
                      onClick: {
                        type: "API_CALL",
                        api: {
                          url: "https://smartpay.easebuzz.in/payment_links/v1/easy-collect/${hash_url}/",
                          method: "POST",
                          payload: {
                            amount: "$amount",
                            email: "$email"
                          },
                          headers: {
                            "X-CSRFToken": "$cookies.csrftoken",
                            'Content-Type': 'application/json'
                          }
                        },
                        onSuccess: {
                          type: "INITIATE_PAYMENT_FLOW"
                        },
                        onFailure: {
                          type: "SHOW_ERROR",
                          messageKey: "error_desc"
                        }
                      },
                    },
                    visibility: {
                      dataKey: 'payment_type',
                      operator: 'equals',
                      value: 'SP',
                    },
                    children: [
                      {
                        id: 'pay_button_pretext',
                        component: 'Text',
                        default_value: 'Pay',
                        layout: {
                          width: '100%',
                        },
                        styles: {
                          marginRight: '5px',
                          display: 'flex',
                          justifyContent: 'center',
                        },
                      }
                    ],
                  },
                ],
              },
              {
                id: 'payment_footer',
                component: 'Container',
                layout: {
                  display: 'flex',
                  justifyContent: 'flex-end',
                  marginTop: '8px',
                },
                responsive: {
                  mobile: {
                    display: 'none'
                  },
                },
                children: [
                  {
                    id: 'powered_by_text',
                    component: 'Text',
                    default_value: 'Powered by',
                    styles: {
                      fontSize: '13px',
                      color: '#6B7280',
                    },
                  },
                  {
                    id: 'easebuzz_logo',
                    component: 'Image',
                    props: {
                      src: 'data:image/png;base64,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',
                    },
                    styles: {
                      height: '18px',
                      width: '6rem',
                      objectFit: 'contain',
                    },
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
  },
  post_payment_page: {
    meta: {
      version: 1,
      page_id: 'post_payment_page',
    },
    layout: {
      display: 'flex',
      flexDirection: 'row',
      padding: '90px 16px',
      width: '100%',
      minHeight: '100vh',
      background: '#F4F6FA',
      margin: '0 auto',
    },
    styles: {
      fontFamily: 'Georama',
    },
    responsive: {
      mobile: {
        flexDirection: 'column',
        padding: '4px 24px 0px 24px',
        fontSize: '0.8rem'
      },
    },
    children: [
      {
        id: 'center_panel',
        component: 'Container',
        layout: {
          display: 'flex',
          flexDirection: 'column',
          maxWidth: '720px',
          width: '100%',
          margin: '0 auto',
        },
        responsive: {
          mobile: {
            width: '100%',
            gap: '12px'
          },
        },
        children: [
          {
            id: 'branding_header',
            component: 'Container',
            layout: {
              display: 'none',
            },
            responsive: {
              mobile: {
                display: 'flex',
                justifyContent: 'flex-end',
                marginTop: '8px',
                fontSize: '0.7rem',
                alignItems: 'center'
              },
            },
            children: [
              {
                id: 'powered_by_text',
                component: 'Text',
                default_value: 'Powered by ',
                styles: {
                  color: '#6B7280',
                },
              },
              {
                id: 'easebuzz_logo',
                component: 'Image',
                props: {
                  src: 'data:image/png;base64,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',
                },
                styles: {
                  height: '18px',
                  width: '6rem',
                  objectFit: 'contain',
                },
                responsive: {
                  mobile: {
                    height: '0.7rem',
                    width: '5rem'
                  },
                },
              },
            ],
          },
          {
            id: 'header_card',
            component: 'Container',
            layout: {
              width: '100%',
            },
            styles: {
              background: '#000000',
              padding: '24px',
              borderRadius: '16px',
              display: 'flex',
              alignItems: 'center',
              gap: '16px',
              color: '#FFFFFF',
              boxShadow: '0 8px 24px rgba(0,0,0,0.08)',
            },
            children: [
              {
                id: 'merchant_logo',
                component: 'Image',
                props: {
                  src: 'data:image/png;base64,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',
                  alt: 'merchant_logo',
                },
                layout: {},
                styles: {
                  width: '82px',
                  height: '62px',
                  zoom: 1.3,
                  borderRadius: '12px',
                  objectFit: 'contain',
                  background: '#FFFFFF',
                  padding: '8px',
                },
              },
              {
                id: 'main_link_details',
                component: 'Container',
                styles: {
                  display: 'flex',
                  flexDirection: 'row',
                  justifyContent: 'flex-end',
                  fontSize: '15px',
                  opacity: 0.9,
                },
                responsive: {
                  mobile: {
                    display: 'inline',
                    fontSize: '15px',
                    opacity: 0.9,
                  },
                },
                children: [
                  {
                    id: 'paying_to_merchant_success_wrapper',
                    component: 'Container',
                    layout: {
                      width: '100%',
                    },
                    styles: {
                      display: 'flex',
                      flexDirection: 'row',
                      fontSize: '1.5rem',
                      margin: '10px 0px',
                    },
                    responsive: {
                      mobile: {
                        display: 'block',
                      },
                    },
                    visibility: {
                      dataKey: 'data.payment_details.status',
                      operator: 'equals',
                      value: 'success',
                    },
                    children: [
                      {
                        id: 'payment_successful_text',
                        component: 'Text',
                        default_value: 'Payment confirmation',
                        styles: {
                          fontWeight: '700'
                        },
                      }
                    ],
                  },
                  {
                    id: 'paying_to_merchant_failure_wrapper',
                    component: 'Container',
                    layout: {
                      width: '100%',
                    },
                    styles: {
                      display: 'flex',
                      flexDirection: 'row',
                      fontSize: '1.5rem',
                      margin: '10px 0px',
                    },
                    responsive: {
                      mobile: {
                        display: 'block',
                      },
                    },
                    visibility: {
                      dataKey: 'data.payment_details.status',
                      operator: 'not_equals',
                      value: 'success',
                    },
                    children: [
                      {
                        id: 'payment_unsuccessful_text',
                        component: 'Text',
                        default_value: 'Payment attempt unsuccessful',
                        styles: {
                          fontWeight: '700'
                        },
                      }
                    ],
                  },
                ],
              },
            ],
          },
          {
            id: 'transaction_details_wrapper',
            component: 'Container',
            layout: {
              width: '100%',
            },
            styles: {
              minHeight: '66vh',
              backgroundColor: '#FFFFFF',
              borderRadius: '16px',
              boxShadow: '0 8px 24px rgba(0,0,0,0.08)',
            },
            children: [
              {
                id: 'success_section',
                component: 'Container',
                styles: {
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  justifyContent: 'center',
                  padding: '24px 90px',
                  borderRadius: '16px',
                  textAlign: 'center',
                  backgroundColor: '#FFFFFF',
                },
                visibility: {
                  dataKey: 'data.payment_details.status',
                  operator: 'equals',
                  value: 'success',
                },
                responsive: {
                  mobile: {
                    padding: '24px 24px 0px',
                  }
                },
                children: [
                  {
                    id: 'success_icon',
                    component: 'Text',
                    default_value: '✓',
                    styles: {
                      width: '6rem',
                      height: '6rem',
                      borderRadius: '50%',
                      border: '3px solid #16A34A',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      fontSize: '4rem',
                      fontWeight: '700',
                      color: '#16A34A',
                    },
                    responsive: {
                      mobile: {
                        width: '3rem',
                        height: '3rem',
                        fontSize: '2rem',
                      }
                    }
                  },
                  {
                    id: 'success_title',
                    component: 'Text',
                    default_value: 'Payment Successful!',
                    styles: {
                      fontSize: '2rem',
                      fontWeight: '700',
                      color: '#16A34A',
                      marginBottom: '16px',
                    },
                    responsive: {
                      mobile: {
                        fontSize: '1.2rem',
                      }
                    }
                  },
                  {
                    id: 'success_description',
                    component: 'Text',
                    default_value: 'Transaction Successful. Payment receipt will be sent within 30 minutes to your registered email ID. Payment is subject to realization.',
                    visibility: {
                      dataKey: 'data.payment_details.status',
                      operator: 'equals',
                      value: 'success',
                    },
                    styles: {
                      fontSize: '1rem',
                      lineHeight: '28px',
                      color: '#6B7280',
                      textAlign: 'center'
                    },
                    responsive: {
                      mobile: {
                        lineHeight: '24px',
                        fontSize: '0.8rem',
                      },
                    },
                  }
                ],
              },
              {
                id: 'failure_section',
                component: 'Container',
                styles: {
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  justifyContent: 'center',
                  padding: '24px 90px',
                  textAlign: 'center',
                  backgroundColor: '#FFFFFF',
                },
                responsive: {
                  mobile: {
                    padding: '24px 24px 0px',
                  }
                },
                visibility: {
                  dataKey: 'data.payment_details.status',
                  operator: 'not_equals',
                  value: 'success',
                },
                children: [
                  {
                    id: 'failure_icon',
                    component: 'Text',
                    default_value: '✕',
                    styles: {
                      width: '6rem',
                      height: '6rem',
                      borderRadius: '50%',
                      border: '3px solid #e45260',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      fontSize: '4rem',
                      fontWeight: '700',
                      color: '#e45260',
                    },
                    responsive: {
                      mobile: {
                        width: '3rem',
                        height: '3rem',
                        fontSize: '2rem',
                      }
                    }
                  },
                  {
                    id: 'failure_title',
                    component: 'Text',
                    default_value: 'Payment Failed!',
                    styles: {
                      fontSize: '2rem',
                      fontWeight: '700',
                      color: '#e45260',
                      marginBottom: '16px',
                    },
                    responsive: {
                      mobile: {
                        fontSize: '1.2rem',
                      }
                    }
                  },
                  {
                    id: 'failure_description',
                    component: 'Text',
                    default_value: 'Sorry! Something went wrong. If the funds were debited, the refund to the originating bank account will be processed within 3 to 5 business working days.',
                    visibility: {
                      dataKey: 'data.payment_details.status',
                      operator: 'not_equals',
                      value: 'success',
                    },
                    styles: {
                      fontSize: '1rem',
                      lineHeight: '28px',
                      color: '#6B7280',
                      textAlign: 'center'
                    },
                    responsive: {
                      mobile: {
                        lineHeight: '24px',
                        fontSize: '0.8rem',
                      },
                    },
                  },
                ],
              },
              {
                id: 'transaction_information_card',
                component: 'Container',
                styles: {
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  background: '#F9FAFB',
                  borderRadius: '16px',
                  padding: '24px',
                  gap: '10px',
                  margin: '8px 90px',
                  fontSize: '1rem',
                  backgroundColor: 'rgba(249, 249, 249, 1)',
                },
                responsive: {
                  mobile: {
                    margin: '8px',
                    fontSize: '0.8rem',
                  }
                },
                children: [
                  {
                    id: 'txn_amount_wrapper',
                    component: 'Container',
                    layout: {
                      display: 'flex',
                      flexDirection: 'row',
                      justifyContent: 'space-between',
                    },
                    children: [
                      {
                        id: 'txn_amount_label',
                        component: 'Text',
                        default_value: 'Amount:',
                        styles: {
                          fontWeight: '600',
                          color: '#42526d',
                        },
                      },
                      {
                        id: 'txn_amount_value_wrapper',
                        component: 'Container',
                        dataKey: 'amount',
                        styles: {
                          display: 'flex',
                          flexDirection: 'row',
                          color: '#111827'
                        },
                        children: [
                          {
                            id: 'total_amount_value_pretext',
                            component: 'Text',
                            default_value: '₹',
                            styles: {
                              marginRight: '5px',
                            },
                          },
                          {
                            id: 'txn_amount_value',
                            component: 'Text',
                            default_value: '',
                            dataKey: 'data.payment_details.amount',
                            styles: {
                              color: '#111827',
                            },
                          },
                        ],
                      },
                    ],
                  },
                  {
                    id: 'txn_date_wrapper',
                    component: 'Container',
                    layout: {
                      display: 'flex',
                      flexDirection: 'row',
                      justifyContent: 'space-between',
                    },
                    children: [
                      {
                        id: 'txn_date_label',
                        component: 'Text',
                        default_value: 'Date:',
                        styles: {
                          fontWeight: '600',
                          color: '#42526d',
                        },
                      },
                      {
                        id: 'txn_date_value',
                        component: 'Text',
                        dataKey: 'data.payment_details.addedon',
                        default_value: '',
                        styles: {
                          color: '#111827',
                        },
                      },
                    ],
                  },
                  {
                    id: 'name_wrapper',
                    component: 'Container',
                    layout: {
                      display: 'flex',
                      flexDirection: 'row',
                      justifyContent: 'space-between',
                    },
                    children: [
                      {
                        id: 'name_label',
                        component: 'Text',
                        dataKey: 'data.easycollect_fields.name',
                        default_value: 'Name:',
                        styles: {
                          fontWeight: '600',
                          color: '#42526d',
                        },
                      },
                      {
                        id: 'name_value',
                        component: 'Text',
                        dataKey: 'data.firstname',
                        default_value: '',
                        styles: {
                          color: '#111827',
                        },
                      },
                    ],
                  },
                  {
                    id: 'email_wrapper',
                    component: 'Container',
                    layout: {
                      display: 'flex',
                      flexDirection: 'row',
                      justifyContent: 'space-between',
                    },
                    children: [
                      {
                        id: 'email_label',
                        component: 'Text',
                        default_value: 'Email ID:',
                        styles: {
                          fontWeight: '600',
                          color: '#42526d',
                        },
                      },
                      {
                        id: 'email_value',
                        component: 'Text',
                        default_value: '',
                        dataKey: 'data.payment_details.email',
                        styles: {
                          color: '#111827',
                          wordBreak: 'break-word',
                        },
                      },
                    ],
                  },
                  {
                    id: 'txn_id_wrapper',
                    component: 'Container',
                    layout: {
                      display: 'flex',
                      flexDirection: 'row',
                      justifyContent: 'space-between',
                    },
                    children: [
                      {
                        id: 'txn_id_label',
                        component: 'Text',
                        default_value: 'Transaction ID:',
                        styles: {
                          fontWeight: '600',
                          color: '#42526d',
                        },
                      },
                      {
                        id: 'txn_id_value',
                        component: 'Text',
                        dataKey: 'data.payment_details.easepayid',
                        default_value: '',
                        styles: {
                          color: '#111827',
                          wordBreak: 'break-word',
                        },
                      },
                    ],
                  },
                ],
              },
              {
                id: 'transaction_details_footer',
                component: 'Container',
                layout: {
                  width: '50%',
                },
                styles: {
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  gap: '20px',
                  backgroundColor: '#FFFFFF',
                  margin: '0 auto',
                },
                children: [
                  {
                    id: 'payment_action_card',
                    component: 'Container',
                    styles: {
                      background: '#FFFFFF',
                      padding: '32px',
                      borderRadius: '16px',
                    },
                    responsive: {
                      mobile: {
                        position: 'fixed',
                        bottom: '0',
                        left: '0',
                        width: '100%',
                        zIndex: '999',
                        background: '#FFFFFF',
                        padding: '1.25rem',
                        borderRadius: '24px',
                        boxShadow: '0 -4px 24px rgba(0,0,0,0.12)',
                      },
                    },
                    children: [
                      {
                        id: 'success_redirect_btn',
                        component: 'Link',
                        props: {
                          href: 'https://www.mahindralifespaces.com/',
                        },
                        visibility: {
                          dataKey: 'data.payment_details.status',
                          operator: 'equals',
                          value: 'success',
                        },
                        styles: {
                          display: 'flex',
                          flexDirection: 'row',
                          justifyContent: 'center',
                          fontSize: '1.2rem',
                          color: '#FFFFFF',
                          border: '1px solid transparent',
                          borderRadius: '14px',
                          backgroundColor: '#000000',
                          cursor: 'pointer',
                          margin: '0 auto',
                          textAlign: 'center',
                          padding: '0.7rem'
                        },
                        children: [
                          {
                            id: 'success_redirect_text1',
                            component: 'Text',
                            default_value: 'Visit',
                            styles: {
                              marginRight: '0.3rem'
                            }
                          },
                          {
                            id: 'success_redirect_text2',
                            component: 'Text',
                            default_value: 'Mahindra Lifespaces \u2192',
                            styles: {
                              fontWeight: "900"
                            }
                          }
                        ]
                      },
                      {
                        id: 'retry_payment_button',
                        component: 'Button',
                        visibility: {
                          dataKey: 'data.payment_details.status',
                          operator: 'not_equals',
                          value: 'success',
                        },
                        actions: {
                          onClick: {
                            type: "REDIRECT",
                            urlDataKey: "retry"
                          }
                        },
                        styles: {
                          display: 'flex',
                          flexDirection: 'row',
                          justifyContent: 'center',
                          alignItems: 'center',
                          width: '100%',
                          height: '56px',
                          border: 'none',
                          borderRadius: '14px',
                          background: '#000000',
                          color: '#FFFFFF',
                          fontSize: '22px',
                          fontWeight: '900',
                          cursor: 'pointer',
                        },
                        "children": [
                          {
                            id: 'retry_payment_button',
                            component: 'Text',
                            default_value: 'Retry Payment'
                          }
                        ]
                      },
                    ]
                  }
                ],
              },
            ],
          }
        ],
      },
    ],
  },
};

export { BASE_CONFIG }
